import { TcountryCode } from 'components/NudosComponents/BordFlag/BordFlag.types';
import BordFlag from 'components/NudosComponents/BordFlag/BordFlag';
import { IStorageBillingInvoices } from 'types/billing.types';
import './StorageInfo.scss';

interface IStorageInfoProps {
  billingInvoice?: IStorageBillingInvoices;
  isLoading: boolean;
}

const StorageInfo = ({ billingInvoice, isLoading }: IStorageInfoProps) => {
  const warehouseLocation = billingInvoice?.warehouseLocation;
  if (isLoading) return <div className="storageInfoSkeleton animationLoader" />;
  return (
    <div className="storageInfo">
      <div className="storageInfoHeader">
        <div className="storageInfoHeaderTitle">
          <span>Información del almacenamiento</span>
        </div>
      </div>
      <div className="internalDivider" />
      <div className="storageInfoBody">
        <div className="storageWarehouseInfo">
          <span className="storageWarehouseInfoTitle">Bodega</span>
          <div className="storageWarehouseCountryInfo">
            <BordFlag country={warehouseLocation?.countryCode as TcountryCode} variant="circle" customWidth="14px" />
            <span className="storageWarehouseCountryName"> Bodega {warehouseLocation?.country}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorageInfo;
